import React from 'react';
import { useL10n } from '^/hooks';
import styled from 'styled-components';
import Text from './text';
import theme from '^/theme';

const TextContainer = styled.p({
  fontWeight: '400',
  fontSize: '10px',
  lineHeight: '150%',
  marginTop: '12px',
  textAlign: 'center',
  color: theme.colorTokens.textCool,
});

export function ReachedLastRequest() {
  const [l10n] = useL10n();
  return <TextContainer>{l10n(Text.reachedLast)}</TextContainer>;
}
